module.exports = __webpack_public_path__ + "assets/img/2-1.1a4f39ce.jpg";